import React from 'react'

import {
    Table,
    OverlayTrigger,
} from 'react-bootstrap'

// icons
import FeatherIcon from 'feather-icons-react';

// loading
import AbandonedCartLodingSkeleton from './table__loadingSkeleton'

// react router
import { Link } from 'react-router-dom'

import { renderTooltipDelete, renderTooltipView } from '../tooltips/AbandonedCart__Tooltips'

export default function AbandonedCartTable(props) {

    return (
        <Table responsive className="mb-0">
            <thead>
                <tr>
                    {
                        props.column__userEmail && (
                            <th>
                                <p className="text-capitalize">
                                    User Email
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__orderDate && (
                            <th>
                                <p className="text-capitalize">
                                    Order Date
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__cartItems && (
                            <th className="text-end">
                                <p className="text-capitalize">
                                    Cart Items
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__total && (
                            <th className="text-end">
                                <p className="text-capitalize">
                                    Total
                                </p>
                            </th>
                        )
                    }

                    <th width="60"></th>
                </tr>
            </thead>

            <tbody>
                {
                    props.loading ? (
                        <React.Fragment>
                            {
                                (props.loadingCount && props.loadingCount.length) && props.loadingCount.map(item => (
                                    <React.Fragment key={item}>
                                        <AbandonedCartLodingSkeleton />
                                    </React.Fragment>
                                ))
                            }
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {
                                (props.abandonedCart && props.abandonedCart.length) ? props.abandonedCart.map(item => {
                                    return (
                                        <tr key={item.temp_order_id}>
                                            {
                                                props.column__userEmail && (
                                                    <td className="column__userEmail">
                                                        <Link to={`/my-sales/abandoned-carts/details/${item.temp_order_id}`} className="st-text-primary st-fs-15 hover-underline-link">
                                                            {item.customer_email || item.customer_name}
                                                        </Link>
                                                        { // if reminder email is sent already
                                                            (item.send_reminder) ? (
                                                                <p className="email-sent st-text-color2 mt-1">
                                                                    <FeatherIcon
                                                                        icon="check"
                                                                        size="15"
                                                                        className="icon"
                                                                    />
                                                                    <span className="ms-1">
                                                                        Reminder email sent
                                                                    </span>
                                                                </p>
                                                            ) : null
                                                        }
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__orderDate && (
                                                    <td className="column__orderDate">
                                                        <p className="">
                                                            {item.cart_date}
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__cartItems && (
                                                    <td className="column__cartItems text-end">
                                                        <p className="">
                                                            {item.cart_items}x
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            {
                                                props.column__total && (
                                                    <td className="column__total text-end">
                                                        <p className="">
                                                            {item.cart_total}
                                                        </p>
                                                    </td>
                                                )
                                            }

                                            <td className="column__actions">
                                                <div className="d-flex justify-content-end">
                                                    <OverlayTrigger
                                                        placement={"left"}
                                                        overlay={renderTooltipView}
                                                    >
                                                        <Link
                                                            to={{
                                                                pathname: `/my-sales/abandoned-carts/details/${item.temp_order_id}`
                                                            }}
                                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center me-1"
                                                        >
                                                            <FeatherIcon
                                                                icon="eye"
                                                                size="15"
                                                                className="icon" />
                                                        </Link>
                                                    </OverlayTrigger>

                                                    {/* <OverlayTrigger
                                                        placement={"left"}
                                                        overlay={renderTooltipDelete}
                                                    >
                                                        <button
                                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                                            onClick={ev => props.handleDelete(ev, item.blog_id)}
                                                        >
                                                            <FeatherIcon
                                                                icon="trash"
                                                                size="15"
                                                                className="icon" />
                                                        </button>
                                                    </OverlayTrigger> */}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }) : (
                                    !props.loading ? (
                                        <tr>
                                            <td colSpan="11">
                                                <p className="no-data-found text-center st-fw-700 py-1">
                                                    no data found
                                                </p>
                                            </td>
                                        </tr>
                                    ) : null
                                )
                            }
                        </React.Fragment>
                    )
                }

            </tbody>
        </Table>
    )
}
